module.exports = __webpack_public_path__ + "static/media/icono_favoritos_blanco.efcc8c25.svg";